import { useMutation, useQueryClient } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';
import { QueryKeys } from '../queries/constants';

export const useUpdatePaymentPlan = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: paymentRepo.updatePaymentPlan,
    onSuccess: () => {
      // when payment plan id has been changed - we need to refetch PAYMENT_PLAN query
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PAYMENT_PLAN] });
    },
  });

  return useMutationMemoized(mutation);
};

export type UpdatePaymentPlanMutation = ReturnType<typeof useUpdatePaymentPlan>;
